import { createAsyncThunk } from '@reduxjs/toolkit';
import * as Sentry from '@sentry/gatsby';
import { getApiError } from '../../utils';
import Axios from '../../utils/Axios';

export const fetchLoanOfficer = createAsyncThunk<LoanOfficer, string>(
  'loanofficer/fetchLoanOfficer',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await Axios.get(`/contacts/loan-officer/${id}/`);
      return response.data;
    } catch (error: unknown) {
      Sentry.captureException(error);

      const normalizedError = getApiError(error);
      return rejectWithValue(normalizedError);
    }
  },
);
